module.exports = __webpack_public_path__ + "img/empty.90782bc9.png";